export { default } from './SkeletonHotelLowRateCalendar';
